import { Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class PJKeys extends MainKeys {
    get place() {
        return Places.pj
    }
}

export default PJKeys
